import gql from "graphql-tag";

export default gql`
  query getCreditCommentary($query: QueryInput, $offset: OffsetInput) {
    getCreditCommentary(query: $query, offset: $offset) {
      __typename
      id
      friendly_entity_id
      subject_type
      subject_id
      effective_time
      category
      detail
      current
      user
    }
  }
`;
